var _style, _tspan, _tspan2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletLoginAnimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-tablet-login",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-tablet-login:not(.animated) .animable {opacity: 0;}svg#freepik_stories-tablet-login.animated #freepik--background-complete--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-tablet-login.animated #freepik--Shadow--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-tablet-login.animated #freepik--Plant--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-tablet-login.animated #freepik--Streetlight--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-tablet-login.animated #freepik--Screen--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-tablet-login.animated #freepik--speech-bubble--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-tablet-login.animated #freepik--Character--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}            @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-26",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "el9trlkesure",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "elu3id61alxqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "elzmalnhxlae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "elbg2ofpgb3k7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "el8zf5varhmqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "elvn76ifz4ta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "elnnr1is6118",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el5ax8d1vfixq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "ellzg4p23qd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.56,365.34c-.24-2.86.15-6.56,3.49-7.66,5.65-1.86,9-6.24,8.81-11.19s5.76-9.77,10.22-5.13,3.87-3.57,9.82-5.56,11,2.84,9.36,7.27,4.25,7.18,11.28,3.42,14.76,3.08,13.27,8.43-.27,5.95,4.18,4.17c3.6-1.44,9.48,1.58,10.13,6.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.811px 350.339px"
    },
    id: "elesndr2npskd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.07,365.34c-.27-2.26-.15-5.56,2.65-6.49,4.39-1.45,7-4.85,6.85-8.69s4.47-7.58,7.93-4,3-2.77,7.62-4.32,8.54,2.21,7.27,5.64,3.3,5.58,8.75,2.66,11.46,2.39,10.31,6.55-.21,4.62,3.24,3.23c2.93-1.17,7.79,1.47,7.9,5.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "393.281px 353.41px"
    },
    id: "elk3xpalv4lss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.82,365.34H288.11c-1.44-4.82,2.29-10.6,6.36-11.41,5-1,10-9.8,10.27-15.4S314,315.7,328,326.34s9.75,1.56,19.87-1.43,16.52,5.61,12.08,12.07c0,0,10.17-2.55,14.36,6.95s0,15.4,0,15.4S387.14,359,390.82,365.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "339.307px 344.14px"
    },
    id: "elcrx484jc0sc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.25,95.77A4.83,4.83,0,0,0,198,91.14a10.28,10.28,0,0,0-10.13-11.71,9.74,9.74,0,0,0-1.88.18,8.94,8.94,0,0,0-16.58,4.52h-.15a8.24,8.24,0,0,0,0,16.48h30.26A4.82,4.82,0,0,0,204.25,95.77Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "182.635px 87.9606px"
    },
    id: "elvsdt7xnde4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.48,124.25a4.83,4.83,0,0,0-6.21-4.63,10.21,10.21,0,0,0-10.12-11.71,9.77,9.77,0,0,0-1.89.18,8.94,8.94,0,0,0-16.58,4.52h-.14a8.24,8.24,0,0,0,0,16.48h30.25A4.82,4.82,0,0,0,383.48,124.25Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "361.89px 116.441px"
    },
    id: "elrfpe1xg93t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.87,110.24a3,3,0,0,0-3-3,3.08,3.08,0,0,0-.86.12,5.53,5.53,0,0,0,.07-.92,6.36,6.36,0,0,0-6.36-6.36,6.45,6.45,0,0,0-1.17.11A5.56,5.56,0,0,0,252.23,103h-.09a5.12,5.12,0,1,0,0,10.24H271A3,3,0,0,0,273.87,110.24Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "260.445px 105.371px"
    },
    id: "elwgmsdomdpe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.74,104.37a3,3,0,0,0-3-3,2.71,2.71,0,0,0-.86.13,7,7,0,0,0,.06-.93,6.35,6.35,0,0,0-6.35-6.35,6.56,6.56,0,0,0-1.18.1,5.55,5.55,0,0,0-10.3,2.81H409a5.13,5.13,0,0,0,0,10.25h18.81A3,3,0,0,0,430.74,104.37Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "417.418px 99.51px"
    },
    id: "el0hjjo8larnbd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.92,122.52a3,3,0,0,0-3-3,2.71,2.71,0,0,0-.86.13,7.14,7.14,0,0,0,.07-.93,6.36,6.36,0,0,0-6.36-6.36,6.56,6.56,0,0,0-1.18.11,5.55,5.55,0,0,0-10.3,2.81H83.2a5.12,5.12,0,1,0,0,10.24H102A3,3,0,0,0,104.92,122.52Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "91.5px 117.655px"
    },
    id: "elspcril5khmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.75,208.15a9.2,9.2,0,0,0,.28-1.87c.23-3.9,4-3.28,7.11-3.81,2.47-.41-4.07-6.65.91-8.67a4.33,4.33,0,0,0,2.41-1.67,2.84,2.84,0,0,0-1.09-3.46,6.73,6.73,0,0,0-3.78-.95c-.81-1-.15-2.47.64-3.48s1.75-2.16,1.45-3.4c-.45-1.88-3.08-2-5-1.58-.7-1.14-.68-2.56-1-3.85s-1.37-2.64-2.69-2.48-2,1.56-3.24,1.85c-1.42.33-2.65-.92-3.76-1.86s-3.06-1.53-3.83-.29c-.46.74-.19,1.78-.66,2.51-.83,1.27-2.79.48-4-.42s-3.16-1.71-4-.47a5.38,5.38,0,0,0-.47,1.31c-.58,1.66-2.38,2.49-3.78,3.56s-2.51,3.19-1.32,4.49c.58.64,1.61.9,1.9,1.72.36,1-.68,1.94-1.51,2.64-1.37,1.17-1.62,4.68.2,5.63.76.41,1.88.53,2.07,1.37s-.6,1.34-1.11,1.92a3.63,3.63,0,0,0,1.11,5.39c.44.21,1,.38,1.14.84a1.69,1.69,0,0,1-.11,1,5.16,5.16,0,0,0-.17,2,.9.9,0,0,0,.23.62,1,1,0,0,0,.58.16c2.63.12,3.9-.81,5.5,1.47a1.91,1.91,0,0,0,.55.58,1.79,1.79,0,0,0,.72.19c1.81.14,3-1,4.64-1.19,2.29-.3,2.78.89,4.8,1.83C378.61,211.24,380.15,210.32,380.75,208.15Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "372.947px 191.207px"
    },
    id: "elaqtr4ycpym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,204.88a9.2,9.2,0,0,0,.28-1.87c.23-3.9,3.95-3.28,7.11-3.81,2.47-.41-4.07-6.65.91-8.67a4.42,4.42,0,0,0,2.41-1.67,2.84,2.84,0,0,0-1.09-3.46,6.75,6.75,0,0,0-3.78-1c-.81-1-.15-2.47.63-3.48s1.75-2.16,1.46-3.4c-.45-1.88-3.08-1.95-5-1.58-.7-1.14-.68-2.56-1-3.85s-1.37-2.64-2.69-2.48-2,1.56-3.24,1.85c-1.42.33-2.65-.92-3.76-1.86s-3.06-1.54-3.83-.29c-.46.74-.19,1.78-.66,2.51-.83,1.27-2.79.48-4-.42s-3.16-1.72-4-.47a5.38,5.38,0,0,0-.47,1.31c-.58,1.66-2.38,2.49-3.78,3.56s-2.51,3.18-1.32,4.49c.58.64,1.61.9,1.9,1.72.36,1-.68,1.94-1.51,2.64-1.38,1.17-1.63,4.67.19,5.63.77.41,1.89.53,2.08,1.37s-.6,1.34-1.11,1.92a3.63,3.63,0,0,0,1.11,5.39c.44.21,1,.38,1.13.84a1.69,1.69,0,0,1-.1,1,5.16,5.16,0,0,0-.17,1.95.9.9,0,0,0,.23.62,1,1,0,0,0,.58.16c2.63.12,3.9-.81,5.5,1.47a1.8,1.8,0,0,0,.55.58,1.6,1.6,0,0,0,.72.18c1.81.15,3-1,4.64-1.18,2.29-.3,2.78.88,4.8,1.83C348.34,208,349.88,207.05,350.48,204.88Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "342.673px 187.902px"
    },
    id: "elft19k8v8x2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.56,185.61a9.42,9.42,0,0,0,.28-1.88c.23-3.9,4-3.28,7.12-3.81,2.47-.41-4.08-6.65.91-8.67a4.34,4.34,0,0,0,2.4-1.67,2.84,2.84,0,0,0-1.08-3.46,6.78,6.78,0,0,0-3.79-1c-.81-1-.15-2.47.64-3.48s1.75-2.16,1.45-3.4c-.45-1.88-3.08-1.95-5-1.58-.7-1.14-.69-2.56-1-3.85s-1.37-2.64-2.69-2.48-2,1.56-3.23,1.85c-1.42.34-2.65-.92-3.77-1.86s-3.06-1.53-3.83-.29c-.46.74-.18,1.78-.66,2.51-.83,1.27-2.79.48-4-.42s-3.16-1.71-4-.46a5.17,5.17,0,0,0-.47,1.3c-.58,1.66-2.38,2.49-3.78,3.56s-2.51,3.19-1.32,4.49c.58.64,1.61.9,1.9,1.72.37,1-.68,1.94-1.51,2.64-1.37,1.17-1.62,4.68.2,5.64.76.4,1.88.52,2.07,1.36s-.6,1.34-1.11,1.93a3.62,3.62,0,0,0,1.11,5.38c.44.21,1,.38,1.14.84a1.73,1.73,0,0,1-.11,1,5.55,5.55,0,0,0-.17,1.95.9.9,0,0,0,.24.61.93.93,0,0,0,.57.16c2.63.12,3.9-.81,5.5,1.47a2.07,2.07,0,0,0,.55.59,1.83,1.83,0,0,0,.73.18c1.8.15,3-1,4.63-1.19,2.3-.29,2.78.89,4.8,1.84C345.42,188.69,347,187.77,347.56,185.61Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "339.758px 168.618px"
    },
    id: "eleby18pzq3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.62,195.21a9.2,9.2,0,0,0,.28-1.88c.23-3.89,4-3.28,7.12-3.81,2.47-.41-4.08-6.65.91-8.66a4.41,4.41,0,0,0,2.4-1.68,2.82,2.82,0,0,0-1.09-3.45,6.57,6.57,0,0,0-3.78-.95c-.81-1-.15-2.48.64-3.49s1.75-2.15,1.45-3.4c-.45-1.88-3.08-1.94-5-1.58-.7-1.13-.69-2.55-1-3.84s-1.37-2.65-2.69-2.49-2,1.57-3.23,1.85c-1.42.34-2.65-.92-3.77-1.86s-3.06-1.53-3.83-.29c-.46.74-.18,1.78-.66,2.51-.83,1.27-2.79.48-4-.42s-3.16-1.71-4-.46a5.17,5.17,0,0,0-.47,1.3c-.58,1.66-2.38,2.49-3.78,3.56s-2.51,3.19-1.32,4.49c.58.64,1.61.9,1.9,1.72.37,1-.68,1.94-1.51,2.64-1.37,1.18-1.62,4.68.2,5.64.76.4,1.88.52,2.07,1.37s-.6,1.34-1.11,1.92a3.62,3.62,0,0,0,1.11,5.38c.44.21,1,.38,1.14.84a1.73,1.73,0,0,1-.11,1,5.55,5.55,0,0,0-.17,1.95.89.89,0,0,0,.23.61,1,1,0,0,0,.58.16c2.63.12,3.9-.81,5.5,1.48a2,2,0,0,0,.55.58,1.79,1.79,0,0,0,.73.18c1.8.15,3-1,4.63-1.19,2.3-.29,2.78.89,4.8,1.84C325.48,198.29,327,197.37,327.62,195.21Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "319.818px 178.25px"
    },
    id: "elaaf1x8cwgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.47,190.77a9.2,9.2,0,0,0,.28-1.87c.23-3.9,3.95-3.28,7.11-3.81,2.47-.41-4.07-6.66.91-8.67a4.38,4.38,0,0,0,2.41-1.68,2.83,2.83,0,0,0-1.09-3.45,6.75,6.75,0,0,0-3.78-.95c-.81-1-.15-2.47.63-3.48s1.75-2.16,1.46-3.4c-.46-1.88-3.08-2-5-1.58-.7-1.14-.68-2.56-1-3.85s-1.37-2.64-2.69-2.48-2,1.56-3.24,1.85c-1.42.33-2.65-.92-3.76-1.87s-3.07-1.53-3.83-.28c-.46.74-.19,1.77-.67,2.51-.82,1.26-2.79.48-4-.42s-3.16-1.72-4-.47a5.24,5.24,0,0,0-.47,1.31c-.58,1.66-2.38,2.49-3.78,3.55s-2.51,3.19-1.32,4.5c.58.64,1.61.9,1.9,1.72.36,1-.68,1.94-1.51,2.64-1.38,1.17-1.63,4.67.19,5.63.77.4,1.89.53,2.08,1.37s-.6,1.34-1.11,1.92a3.63,3.63,0,0,0,1.11,5.39c.44.21,1,.38,1.13.84a1.69,1.69,0,0,1-.1,1,5.35,5.35,0,0,0-.18,1.95.7.7,0,0,0,.82.78c2.63.12,3.89-.82,5.5,1.47a1.7,1.7,0,0,0,.55.58,1.6,1.6,0,0,0,.72.18c1.81.15,3-1,4.64-1.19,2.29-.29,2.78.89,4.8,1.84C305.33,193.86,306.87,192.94,307.47,190.77Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "299.657px 173.814px"
    },
    id: "elxi2jashdk6k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2,212.33a7.67,7.67,0,0,0,.23-1.48c.18-3.06,3.11-2.58,5.6-3,1.94-.33-3.21-5.24.71-6.83a3.48,3.48,0,0,0,1.9-1.32,2.23,2.23,0,0,0-.86-2.72,5.28,5.28,0,0,0-3-.75c-.64-.77-.12-2,.5-2.74s1.38-1.7,1.15-2.68c-.36-1.48-2.43-1.53-3.92-1.24a10.93,10.93,0,0,1-.81-3c-.27-1-1.07-2.08-2.12-2s-1.58,1.22-2.54,1.45c-1.12.27-2.09-.72-3-1.47s-2.41-1.2-3-.22c-.36.58-.15,1.4-.52,2-.66,1-2.2.38-3.16-.33s-2.49-1.35-3.16-.36a4,4,0,0,0-.38,1c-.45,1.31-1.87,2-3,2.81s-2,2.51-1,3.53c.46.51,1.27.71,1.5,1.36s-.54,1.52-1.19,2.08c-1.08.92-1.28,3.68.15,4.43.6.32,1.49.42,1.63,1.08s-.47,1.06-.87,1.51a2.85,2.85,0,0,0,.87,4.24c.35.17.77.3.9.66a1.42,1.42,0,0,1-.08.81,4.15,4.15,0,0,0-.14,1.53.67.67,0,0,0,.19.48.7.7,0,0,0,.45.13c2.07.09,3.07-.64,4.33,1.16a1.57,1.57,0,0,0,.43.46,1.26,1.26,0,0,0,.57.14c1.43.12,2.36-.77,3.66-.93,1.8-.23,2.18.7,3.77,1.44C305.52,214.76,306.73,214,307.2,212.33Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "301.035px 198.957px"
    },
    id: "el67cedl99nbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.91,204.88a9.2,9.2,0,0,0,.28-1.87c.24-3.9,3.95-3.28,7.12-3.81,2.47-.41-4.08-6.65.91-8.67a4.39,4.39,0,0,0,2.4-1.67,2.84,2.84,0,0,0-1.08-3.46,6.78,6.78,0,0,0-3.79-1c-.81-1-.15-2.47.64-3.48s1.75-2.16,1.45-3.4c-.45-1.88-3.08-1.95-5-1.58-.7-1.14-.69-2.56-1-3.85s-1.37-2.64-2.69-2.48-2,1.56-3.23,1.85c-1.42.33-2.65-.92-3.77-1.86s-3.06-1.54-3.83-.29c-.46.74-.18,1.78-.66,2.51-.83,1.27-2.79.48-4-.42s-3.16-1.72-4-.47a5.38,5.38,0,0,0-.47,1.31c-.58,1.66-2.37,2.49-3.77,3.56s-2.52,3.18-1.33,4.49c.58.64,1.61.9,1.9,1.72.37,1-.68,1.94-1.51,2.64-1.37,1.17-1.62,4.67.2,5.63.76.41,1.88.53,2.07,1.37s-.6,1.34-1.1,1.92a3.62,3.62,0,0,0,1.1,5.39c.44.21,1,.38,1.14.84a1.69,1.69,0,0,1-.11,1,5.6,5.6,0,0,0-.17,1.95.9.9,0,0,0,.24.62.93.93,0,0,0,.57.16c2.63.12,3.9-.81,5.5,1.47a1.91,1.91,0,0,0,.55.58,1.67,1.67,0,0,0,.73.18c1.8.15,3-1,4.64-1.18,2.29-.3,2.77.88,4.79,1.83C293.78,208,295.31,207.05,295.91,204.88Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "288.108px 187.902px"
    },
    id: "elyvpfqwnpzme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.62,171.49a9.2,9.2,0,0,0,.28-1.87c.23-3.9,4-3.28,7.12-3.81,2.47-.41-4.08-6.65.91-8.67a4.34,4.34,0,0,0,2.4-1.67,2.83,2.83,0,0,0-1.09-3.46,6.73,6.73,0,0,0-3.78-.95c-.81-1-.15-2.47.64-3.48s1.75-2.16,1.45-3.4c-.45-1.88-3.08-2-5-1.58-.7-1.14-.69-2.56-1-3.85s-1.37-2.64-2.69-2.48-2,1.56-3.23,1.85c-1.42.34-2.65-.92-3.77-1.86s-3.06-1.53-3.83-.29c-.46.74-.18,1.78-.66,2.51-.83,1.27-2.79.48-4-.42s-3.16-1.71-4-.47a5.38,5.38,0,0,0-.47,1.31c-.58,1.66-2.38,2.49-3.78,3.56s-2.51,3.19-1.32,4.49c.58.64,1.61.9,1.9,1.72.37,1-.68,1.94-1.51,2.64-1.37,1.17-1.62,4.68.2,5.63.76.41,1.88.53,2.07,1.37s-.6,1.34-1.11,1.92a3.63,3.63,0,0,0,1.11,5.39c.44.21,1,.38,1.14.84a1.73,1.73,0,0,1-.11,1,5.55,5.55,0,0,0-.17,2,.89.89,0,0,0,.23.61,1,1,0,0,0,.58.16c2.63.12,3.9-.81,5.5,1.47a2.07,2.07,0,0,0,.55.59,1.79,1.79,0,0,0,.73.18c1.8.15,3-1,4.63-1.19,2.3-.3,2.78.89,4.8,1.84C325.48,174.58,327,173.66,327.62,171.49Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "319.818px 154.547px"
    },
    id: "elmusgdzu0wu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.51,172.82a9.2,9.2,0,0,0,.28-1.88c.23-3.89,3.95-3.28,7.12-3.8,2.47-.42-4.08-6.66.91-8.67a4.41,4.41,0,0,0,2.4-1.68,2.82,2.82,0,0,0-1.09-3.45,6.57,6.57,0,0,0-3.78-1c-.81-1-.15-2.48.64-3.49s1.75-2.15,1.45-3.4c-.45-1.88-3.08-1.94-5-1.58-.7-1.13-.69-2.55-1-3.84s-1.37-2.65-2.69-2.48-2,1.56-3.23,1.84c-1.42.34-2.65-.92-3.77-1.86s-3.06-1.53-3.83-.29c-.46.74-.18,1.78-.66,2.51-.83,1.27-2.79.48-4-.42s-3.16-1.71-4-.46a5.17,5.17,0,0,0-.47,1.3c-.58,1.66-2.38,2.49-3.78,3.56s-2.51,3.19-1.32,4.49c.58.64,1.61.9,1.9,1.72.37,1-.68,1.94-1.51,2.65-1.37,1.17-1.62,4.67.2,5.63.76.4,1.88.52,2.07,1.37s-.6,1.34-1.11,1.92a3.62,3.62,0,0,0,1.11,5.38c.44.21,1,.39,1.14.84a1.72,1.72,0,0,1-.11,1,5.58,5.58,0,0,0-.17,1.95.87.87,0,0,0,.23.61,1,1,0,0,0,.58.16c2.63.12,3.9-.81,5.5,1.48a2,2,0,0,0,.55.58,1.64,1.64,0,0,0,.73.18c1.8.15,3-1,4.63-1.19,2.3-.29,2.78.89,4.8,1.84C351.37,175.9,352.91,175,353.51,172.82Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "345.708px 155.83px"
    },
    id: "elzvhij5bsar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.24,183.41a9.2,9.2,0,0,0,.28-1.87c.23-3.9,4-3.28,7.11-3.81,2.47-.41-4.07-6.65.91-8.67a4.37,4.37,0,0,0,2.41-1.67,2.84,2.84,0,0,0-1.09-3.46,6.75,6.75,0,0,0-3.78-1c-.81-1-.15-2.47.63-3.48s1.75-2.16,1.45-3.4c-.45-1.88-3.07-1.95-5-1.58-.7-1.14-.69-2.56-1-3.85s-1.36-2.64-2.69-2.48-2,1.56-3.23,1.85c-1.42.33-2.65-.92-3.76-1.86s-3.07-1.53-3.83-.29c-.46.74-.19,1.78-.67,2.51-.82,1.27-2.79.48-4-.42s-3.16-1.71-4-.47a5.41,5.41,0,0,0-.48,1.31c-.57,1.66-2.37,2.49-3.77,3.56s-2.51,3.18-1.33,4.49c.59.64,1.62.9,1.91,1.72.36,1-.68,1.94-1.51,2.64-1.38,1.17-1.63,4.68.19,5.63.77.41,1.89.53,2.08,1.37s-.6,1.34-1.11,1.92a3.61,3.61,0,0,0,1.11,5.39c.43.21,1,.38,1.13.84a1.69,1.69,0,0,1-.1,1,5.37,5.37,0,0,0-.18,2,.9.9,0,0,0,.24.62,1,1,0,0,0,.58.16c2.63.12,3.89-.81,5.5,1.47a1.7,1.7,0,0,0,.55.58,1.75,1.75,0,0,0,.72.19c1.81.14,3-1,4.64-1.19,2.29-.3,2.78.89,4.79,1.83C367.1,186.5,368.64,185.58,369.24,183.41Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "361.428px 166.435px"
    },
    id: "elnza32o40qpo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,196.81s-6.58,9.29-8.85,12.24-13.6,21.32-15.15,33.47c-.16,1.3-.32,2.41-.48,3.39,4.87,32.19,4.11,91.09,3.94,101.17H328.48c-.15-11.37-1.46-115.31-1.94-118.48-.52-3.36-7-16.15-17-21.4S291,184.56,291,184.56h3.18s5.9,10.66,14.29,16.55a31.55,31.55,0,0,0,3.78,2.24,53.67,53.67,0,0,1,3.33-18.79l1.72,1.59c-2.32,9.49-2,15.57-1.31,19.06a34.54,34.54,0,0,1,8.68,5.81c8.7-11.32,13.59-37.2,13.59-37.2l2.23,1.21a130.75,130.75,0,0,1-2.88,15.88c-1.63,6.7-6.43,19.31-8.66,25a59.28,59.28,0,0,1,6.58,12.34,5.13,5.13,0,0,1,.84-1c5.67-5.12,16.32-29.34,16.32-29.34,2.58-5.63-1.36-20.41-1.36-20.41h3l1.33,12.93,7.49-8.17,1.36,1.14-7.94,10.2-4.08,12.93,10.66-11.8Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "327.755px 260.45px"
    },
    id: "ele609j3onf0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.66,242.83a6.61,6.61,0,0,1-.22-1.44c-.18-3-3-2.51-5.46-2.92-1.9-.31,3.12-5.1-.7-6.65a3.37,3.37,0,0,1-1.84-1.28,2.18,2.18,0,0,1,.83-2.66,5.18,5.18,0,0,1,2.9-.72c.63-.76.12-1.9-.48-2.68s-1.35-1.65-1.12-2.61c.35-1.44,2.36-1.49,3.82-1.21a10.69,10.69,0,0,0,.78-2.95c.27-1,1-2,2.07-1.9s1.54,1.19,2.48,1.42c1.09.25,2-.71,2.89-1.43s2.35-1.18,2.94-.23c.35.57.14,1.37.51,1.93.63,1,2.14.37,3.07-.32s2.43-1.32,3.08-.36a4,4,0,0,1,.37,1c.44,1.28,1.82,1.91,2.89,2.73s1.93,2.45,1,3.45c-.45.49-1.24.69-1.46,1.32-.28.78.52,1.49,1.16,2,1,.9,1.24,3.58-.15,4.32-.59.31-1.45.4-1.59,1.05s.46,1,.85,1.47a2.79,2.79,0,0,1-.85,4.14c-.34.16-.75.29-.87.64a1.25,1.25,0,0,0,.08.78,4.19,4.19,0,0,1,.13,1.5.68.68,0,0,1-.18.46.7.7,0,0,1-.45.13c-2,.09-3-.62-4.22,1.13a1.39,1.39,0,0,1-.42.45,1.44,1.44,0,0,1-.55.14c-1.39.11-2.29-.76-3.56-.92-1.76-.22-2.13.69-3.68,1.41C85.29,245.2,84.11,244.49,83.66,242.83Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "89.6336px 229.819px"
    },
    id: "elwmtybcfv8oi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88,240.32a7.27,7.27,0,0,1-.22-1.44c-.17-3-3-2.51-5.45-2.92-1.9-.31,3.12-5.1-.7-6.65A3.43,3.43,0,0,1,98.66,228a2.17,2.17,0,0,1,.84-2.65,5.09,5.09,0,0,1,2.9-.73c.62-.76.11-1.9-.49-2.68s-1.34-1.65-1.11-2.61c.34-1.44,2.36-1.49,3.81-1.21a10.37,10.37,0,0,0,.79-3c.26-1,1-2,2.06-1.9s1.55,1.2,2.49,1.42c1.09.25,2-.71,2.88-1.43s2.35-1.18,2.94-.23c.36.57.14,1.37.51,1.93.64,1,2.14.37,3.08-.32s2.42-1.32,3.08-.36a4,4,0,0,1,.36,1c.44,1.28,1.82,1.91,2.9,2.73s1.93,2.45,1,3.45c-.45.49-1.24.69-1.47,1.32-.27.78.53,1.49,1.16,2,1.06.9,1.25,3.58-.15,4.32-.58.31-1.44.4-1.59,1.05s.46,1,.85,1.47a2.78,2.78,0,0,1-.85,4.14c-.33.16-.74.29-.87.64a1.32,1.32,0,0,0,.08.78,4.19,4.19,0,0,1,.14,1.5.73.73,0,0,1-.19.47.71.71,0,0,1-.44.12c-2,.09-3-.62-4.22,1.13a1.05,1.05,0,0,1-1,.59c-1.38.11-2.29-.76-3.56-.92-1.75-.22-2.13.69-3.67,1.41C108.52,242.69,107.34,242,106.88,240.32Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "112.868px 227.26px"
    },
    id: "el2agbui4xi42",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.12,225.53a6.7,6.7,0,0,1-.22-1.44c-.18-3-3-2.51-5.46-2.92-1.89-.32,3.13-5.1-.69-6.65a3.36,3.36,0,0,1-1.85-1.29,2.18,2.18,0,0,1,.83-2.65,5.19,5.19,0,0,1,2.91-.72c.62-.76.11-1.9-.49-2.68s-1.34-1.65-1.11-2.61c.34-1.44,2.36-1.49,3.81-1.21a10.37,10.37,0,0,0,.79-3c.26-1,1-2,2.06-1.9s1.54,1.19,2.48,1.42,2-.71,2.89-1.44,2.35-1.17,2.94-.22c.35.57.14,1.37.51,1.93.63,1,2.14.37,3.08-.32s2.42-1.32,3.08-.36a4.1,4.1,0,0,1,.36,1c.44,1.28,1.82,1.91,2.9,2.73s1.92,2.45,1,3.45c-.44.49-1.23.69-1.46,1.32s.53,1.49,1.16,2c1.06.89,1.25,3.58-.15,4.32-.58.31-1.44.4-1.59,1s.46,1,.85,1.47a2.77,2.77,0,0,1-.85,4.13c-.33.17-.75.3-.87.65a1.32,1.32,0,0,0,.08.78,3.94,3.94,0,0,1,.13,1.49.64.64,0,0,1-.18.47.67.67,0,0,1-.44.13c-2,.09-3-.63-4.22,1.13a1.51,1.51,0,0,1-.42.45,1.35,1.35,0,0,1-.56.13c-1.38.12-2.29-.75-3.56-.91-1.76-.22-2.13.68-3.68,1.41C110.76,227.9,109.58,227.19,109.12,225.53Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "115.113px 212.477px"
    },
    id: "el7x0fcyjayw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,232.9a6.7,6.7,0,0,1-.22-1.44c-.18-3-3-2.52-5.46-2.92-1.89-.32,3.13-5.11-.69-6.65a3.36,3.36,0,0,1-1.85-1.29A2.18,2.18,0,0,1,117,218a5.2,5.2,0,0,1,2.91-.73c.62-.75.11-1.9-.49-2.67s-1.34-1.65-1.11-2.61c.34-1.44,2.36-1.49,3.81-1.21a10.37,10.37,0,0,0,.79-2.95c.26-1,1-2,2.06-1.91s1.54,1.2,2.48,1.42,2-.7,2.89-1.43,2.35-1.17,2.94-.22c.35.57.14,1.37.51,1.93.63,1,2.14.37,3.08-.32s2.42-1.32,3.08-.36a4.1,4.1,0,0,1,.36,1c.44,1.27,1.82,1.91,2.9,2.73s1.92,2.45,1,3.44c-.45.5-1.23.7-1.46,1.33-.28.78.53,1.48,1.16,2,1.06.9,1.25,3.59-.15,4.33-.58.3-1.44.4-1.59,1s.46,1,.85,1.47a2.77,2.77,0,0,1-.85,4.13c-.33.16-.75.29-.87.64a1.35,1.35,0,0,0,.08.79,3.94,3.94,0,0,1,.13,1.49.66.66,0,0,1-.18.47.74.74,0,0,1-.44.13c-2,.09-3-.63-4.22,1.13a1.36,1.36,0,0,1-.42.44,1.22,1.22,0,0,1-.56.14c-1.38.12-2.29-.75-3.56-.91-1.76-.22-2.13.68-3.68,1.41C126.06,235.26,124.88,234.56,124.42,232.9Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "130.403px 219.91px"
    },
    id: "el84lvbr9lpsw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.88,229.5a8.39,8.39,0,0,1-.22-1.44c-.17-3-3-2.52-5.45-2.92-1.9-.32,3.12-5.11-.7-6.66a3.38,3.38,0,0,1-1.85-1.28,2.17,2.17,0,0,1,.84-2.65,5.09,5.09,0,0,1,2.9-.73c.62-.76.12-1.9-.49-2.67s-1.34-1.66-1.11-2.61c.34-1.44,2.36-1.49,3.81-1.21a10.46,10.46,0,0,0,.79-3c.26-1,1-2,2.07-1.91s1.54,1.2,2.48,1.42c1.09.26,2-.71,2.89-1.43s2.35-1.18,2.93-.22c.36.57.15,1.36.51,1.92.64,1,2.14.37,3.08-.32s2.42-1.31,3.08-.35a3.72,3.72,0,0,1,.36,1c.45,1.27,1.83,1.91,2.9,2.73s1.93,2.44,1,3.44c-.45.49-1.24.69-1.46,1.32-.28.79.52,1.49,1.15,2,1.06.9,1.25,3.59-.14,4.32-.59.31-1.45.41-1.59,1s.45,1,.84,1.48a2.77,2.77,0,0,1-.85,4.13c-.33.16-.74.29-.87.64a1.32,1.32,0,0,0,.08.78,4.23,4.23,0,0,1,.14,1.5.67.67,0,0,1-.19.47.65.65,0,0,1-.44.12c-2,.09-3-.62-4.22,1.13a1.4,1.4,0,0,1-.42.45,1.32,1.32,0,0,1-.56.14c-1.38.11-2.29-.75-3.55-.91-1.76-.23-2.13.68-3.68,1.41C141.52,231.86,140.34,231.16,139.88,229.5Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "145.869px 216.444px"
    },
    id: "elwdbkkbhfkqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.08,246a6.22,6.22,0,0,1-.17-1.14c-.14-2.35-2.38-2-4.29-2.3-1.5-.25,2.46-4-.55-5.23a2.66,2.66,0,0,1-1.46-1,1.71,1.71,0,0,1,.66-2.08,4.09,4.09,0,0,1,2.28-.58c.5-.59.1-1.49-.38-2.1s-1.06-1.3-.88-2.06c.28-1.13,1.86-1.17,3-.95a8.54,8.54,0,0,0,.62-2.32c.2-.78.82-1.6,1.62-1.5s1.22.94,2,1.11,1.6-.55,2.27-1.12,1.85-.93,2.32-.18c.27.45.11,1.08.4,1.52.5.77,1.68.29,2.42-.25s1.91-1,2.42-.28a3,3,0,0,1,.29.78c.35,1,1.43,1.51,2.28,2.15s1.52,1.93.8,2.72c-.35.38-1,.54-1.15,1s.41,1.17.91,1.59c.83.71,1,2.83-.11,3.41-.47.24-1.14.31-1.26.82s.36.81.67,1.16a2.19,2.19,0,0,1-.67,3.26c-.26.12-.59.23-.68.5a1,1,0,0,0,.06.62,3.34,3.34,0,0,1,.11,1.18.56.56,0,0,1-.15.37.51.51,0,0,1-.35.09c-1.58.08-2.35-.49-3.32.9a1.1,1.1,0,0,1-.33.35,1.29,1.29,0,0,1-.44.11c-1.09.09-1.8-.6-2.8-.72-1.39-.18-1.68.53-2.9,1.11C141.37,247.9,140.44,247.34,140.08,246Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "144.824px 235.773px"
    },
    id: "elxrtwuo1qpme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75,240.32a6.61,6.61,0,0,1-.22-1.44c-.18-3-3-2.51-5.46-2.92-1.89-.31,3.13-5.1-.69-6.65a3.39,3.39,0,0,1-1.85-1.28,2.17,2.17,0,0,1,.83-2.65,5.12,5.12,0,0,1,2.91-.73c.62-.76.11-1.9-.49-2.68s-1.34-1.65-1.12-2.61c.35-1.44,2.36-1.49,3.82-1.21a10.37,10.37,0,0,0,.79-3c.26-1,1-2,2.06-1.9s1.54,1.2,2.48,1.42c1.09.25,2-.71,2.89-1.43s2.35-1.18,2.94-.23c.35.57.14,1.37.51,1.93.63,1,2.14.37,3.07-.32s2.43-1.32,3.09-.36a4.42,4.42,0,0,1,.36,1c.44,1.28,1.82,1.91,2.9,2.73s1.92,2.45,1,3.45c-.45.49-1.24.69-1.46,1.32-.28.78.53,1.49,1.16,2,1.06.9,1.25,3.58-.15,4.32-.59.31-1.45.4-1.59,1.05s.46,1,.85,1.47a2.78,2.78,0,0,1-.85,4.14c-.34.16-.75.29-.87.64a1.32,1.32,0,0,0,.08.78,4.19,4.19,0,0,1,.13,1.5.67.67,0,0,1-.18.47.75.75,0,0,1-.44.12c-2,.09-3-.62-4.22,1.13a1.51,1.51,0,0,1-.42.45,1.54,1.54,0,0,1-.56.14c-1.39.11-2.29-.76-3.56-.92-1.76-.22-2.13.69-3.68,1.41C150.39,242.69,149.21,242,148.75,240.32Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "154.742px 227.28px"
    },
    id: "elof4lsjiv99h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,214.71a6.8,6.8,0,0,1-.22-1.45c-.18-3-3-2.51-5.46-2.92-1.89-.31,3.13-5.1-.69-6.65a3.34,3.34,0,0,1-1.85-1.28,2.18,2.18,0,0,1,.83-2.65,5.12,5.12,0,0,1,2.91-.73c.62-.76.11-1.9-.49-2.67s-1.34-1.66-1.11-2.61c.34-1.44,2.36-1.5,3.81-1.22a10.37,10.37,0,0,0,.79-2.95c.26-1,1-2,2.06-1.9s1.54,1.2,2.48,1.42,2-.71,2.89-1.43,2.35-1.18,2.94-.22c.35.57.14,1.36.51,1.92.63,1,2.14.37,3.08-.32s2.42-1.31,3.08-.36a4.42,4.42,0,0,1,.36,1c.44,1.28,1.82,1.92,2.9,2.74s1.92,2.44,1,3.44c-.45.49-1.23.69-1.46,1.32-.28.79.53,1.49,1.16,2,1.06.9,1.25,3.59-.15,4.32-.58.31-1.44.4-1.59,1.05s.46,1,.85,1.48a2.77,2.77,0,0,1-.85,4.13c-.33.16-.75.29-.87.64a1.32,1.32,0,0,0,.08.78,4,4,0,0,1,.13,1.5.67.67,0,0,1-.18.47.73.73,0,0,1-.44.12c-2,.09-3-.62-4.22,1.13a1.4,1.4,0,0,1-.42.45,1.36,1.36,0,0,1-.56.14c-1.38.11-2.29-.75-3.56-.91-1.76-.23-2.13.68-3.68,1.41C126.06,217.07,124.88,216.36,124.42,214.71Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "130.413px 201.692px"
    },
    id: "elpneuk91t9qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.55,215.72a7.43,7.43,0,0,1-.21-1.44c-.18-3-3-2.51-5.46-2.92-1.9-.32,3.12-5.11-.7-6.65a3.33,3.33,0,0,1-1.84-1.29,2.17,2.17,0,0,1,.83-2.65,5.1,5.1,0,0,1,2.9-.72c.63-.76.12-1.9-.49-2.68s-1.34-1.65-1.11-2.61c.35-1.44,2.36-1.49,3.82-1.21a10.69,10.69,0,0,0,.78-3c.27-1,1.05-2,2.07-1.9s1.54,1.19,2.48,1.41,2-.7,2.89-1.43,2.35-1.17,2.94-.22c.35.57.14,1.37.5,1.93.64,1,2.15.37,3.08-.32s2.43-1.32,3.08-.36a4.12,4.12,0,0,1,.37,1c.44,1.28,1.82,1.91,2.89,2.73s1.93,2.45,1,3.45c-.45.49-1.24.69-1.46,1.32-.28.78.52,1.49,1.16,2,1,.89,1.24,3.58-.15,4.32-.59.31-1.45.4-1.59,1.05s.46,1,.85,1.47a2.78,2.78,0,0,1-.85,4.13c-.34.16-.75.3-.88.65a1.41,1.41,0,0,0,.08.78,3.94,3.94,0,0,1,.14,1.49.7.7,0,0,1-.18.47.77.77,0,0,1-.45.13c-2,.09-3-.63-4.22,1.13a1.26,1.26,0,0,1-.42.44,1.15,1.15,0,0,1-.55.14c-1.39.12-2.3-.75-3.56-.91-1.76-.22-2.13.68-3.68,1.41C106.19,218.09,105,217.38,104.55,215.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "110.534px 202.674px"
    },
    id: "elm8il8psuyjs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.49,223.85a6.7,6.7,0,0,1-.22-1.44c-.18-3-3-2.51-5.46-2.92-1.89-.32,3.13-5.11-.69-6.65a3.36,3.36,0,0,1-1.85-1.29,2.18,2.18,0,0,1,.83-2.65,5.2,5.2,0,0,1,2.91-.73c.62-.75.11-1.89-.49-2.67s-1.34-1.65-1.11-2.61c.34-1.44,2.35-1.49,3.81-1.21a10.37,10.37,0,0,0,.79-3c.26-1,1-2,2.06-1.91s1.54,1.2,2.48,1.42c1.09.26,2-.7,2.89-1.43s2.35-1.17,2.94-.22c.35.57.14,1.37.51,1.93.63,1,2.14.37,3.08-.32s2.42-1.32,3.08-.36a4.1,4.1,0,0,1,.36,1c.44,1.28,1.82,1.91,2.9,2.73s1.92,2.45,1,3.45c-.45.49-1.23.69-1.46,1.32-.28.78.53,1.48,1.16,2,1.06.9,1.25,3.59-.15,4.33-.58.3-1.44.4-1.59,1.05s.46,1,.85,1.47a2.77,2.77,0,0,1-.85,4.13c-.34.16-.75.3-.87.65a1.32,1.32,0,0,0,.08.78,4.15,4.15,0,0,1,.13,1.49.66.66,0,0,1-.18.47.76.76,0,0,1-.44.13c-2,.09-3-.63-4.22,1.13a1.36,1.36,0,0,1-.42.44,1.22,1.22,0,0,1-.56.14c-1.38.12-2.29-.75-3.56-.91-1.76-.22-2.13.68-3.68,1.41C94.13,226.22,93,225.51,92.49,223.85Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "98.4832px 210.805px"
    },
    id: "elji34l5iltra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.15,234.13s5,7.13,6.78,9.39,10.44,16.36,11.63,25.68c.12,1,.25,1.85.37,2.6-3.74,24.7-3.16,69.89-3,77.63h11.85c.11-8.73,1.12-88.48,1.49-90.91s5.35-12.39,13-16.42,14.27-17.37,14.27-17.37h-2.44s-4.53,8.18-11,12.7a24.55,24.55,0,0,1-2.9,1.72,41.13,41.13,0,0,0-2.56-14.42L132.35,226c1.78,7.28,1.55,12,1,14.63A26.48,26.48,0,0,0,126.7,245c-6.68-8.68-10.43-28.54-10.43-28.54l-1.71.93a99.37,99.37,0,0,0,2.21,12.18c1.25,5.14,4.93,14.82,6.64,19.21a46,46,0,0,0-5,9.47,4,4,0,0,0-.65-.77C113.37,253.58,105.2,235,105.2,235c-2-4.32,1-15.66,1-15.66H104l-1,9.91L97.19,223l-1,.87,6.09,7.83,3.13,9.92-8.18-9.05Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "124.345px 282.945px"
    },
    id: "elerzoxazijl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb3l5mgs8dgm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.29,363.4H441.71a0,0,0,0,1,0,0v11.92a7.92,7.92,0,0,1-7.92,7.92H66.2a7.92,7.92,0,0,1-7.92-7.92V363.4A0,0,0,0,1,58.29,363.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "249.995px 373.32px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-26",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-26",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-26",
    className: "animable",
    style: {
      transformOrigin: "102.699px 346.313px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.42,391.16S104,381,97.53,379.87s-4.55-6-6.24-7.94-6.13,3.72-2.33,9.16.69,3.73,2.33,8.79S106,399.59,105.42,391.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "96.4516px 383.674px"
    },
    id: "elymeagh79ry",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el42uerylkonl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.42,391.16S104,381,97.53,379.87s-4.55-6-6.24-7.94-6.13,3.72-2.33,9.16.69,3.73,2.33,8.79S106,399.59,105.42,391.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      isolation: "isolate",
      opacity: 0.2,
      transformOrigin: "96.4516px 383.674px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,398.21a.45.45,0,0,1-.41-.25c0-.11-5-10.69-2.41-27.54a70.77,70.77,0,0,1,4-14.1c3.14-8.58,5.63-15.36-.06-27.74-1.8-3.92-3.63-7.57-5.41-11.1-6.68-13.26-12-23.73-8-34.33a.45.45,0,0,1,.58-.27.46.46,0,0,1,.27.58c-3.79,10.24,1.41,20.55,8,33.61,1.78,3.54,3.63,7.2,5.43,11.13,5.85,12.72,3.17,20,.08,28.43a69.16,69.16,0,0,0-3.94,13.92c-2.57,16.57,2.28,26.92,2.33,27a.46.46,0,0,1-.22.6A.43.43,0,0,1,105.15,398.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "101.04px 340.531px"
    },
    id: "elj930z8dohvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.39,395.73s-4.2-6.34,1.87-9.6,7.28-.63,11-3,6.6-8,7.24-4.39-3.7,5.7-2.16,7.36S109.17,398.59,101.39,395.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "110.77px 386.886px"
    },
    id: "elcdytue3ia8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.47,288.59s-4.1-12.45,5.22-12.71S95.74,287.27,91.47,288.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "95.5263px 282.233px"
    },
    id: "eliamv7kuye1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.57,298.17s2.77-11.32,9.39-8.94S106.16,298.38,99.57,298.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.393px 293.538px"
    },
    id: "eliedpaftc7hp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.34,299.15s1-9-6-9.22S78.43,297.69,88.34,299.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "83.4688px 294.538px"
    },
    id: "elwpy0tf8e26m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,317.58s-9.42-8.39-12.8-2.14S87.31,323,93,317.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.2717px 317.054px"
    },
    id: "elers54fllcx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68,316.09s1.77-13.94,9.38-9.57S116.31,317.49,109.68,316.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.709px 310.977px"
    },
    id: "el9qzvm5shu25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,336.06s-5.62-14.09,4.82-12.5S123.74,332.64,116.38,336.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "120.551px 329.747px"
    },
    id: "el8ysfn9r1f84",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.36,341.09S91.54,330.71,84.81,334,83.58,347.62,100.36,341.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.1862px 338.283px"
    },
    id: "elvovcom7wtbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.36,364.1s7.51-16.68,14.19-11.06S118.29,367.07,108.36,364.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.48px 358.3px"
    },
    id: "elrfpacvedyog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.45,363.12s2-12.93-5.45-11.89S86.51,360.18,97.45,363.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "92.6217px 357.145px"
    },
    id: "el9f3hxytwzvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellsplut43py"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2,
      transformOrigin: "102.39px 320.297px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.47,288.59s-4.1-12.45,5.22-12.71S95.74,287.27,91.47,288.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "95.5263px 282.233px"
    },
    id: "eloyvdl5pkdup",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.57,298.17s2.77-11.32,9.39-8.94S106.16,298.38,99.57,298.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "105.393px 293.538px"
    },
    id: "elj9gsl4840c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.34,299.15s1-9-6-9.22S78.43,297.69,88.34,299.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.4688px 294.538px"
    },
    id: "ele8dltv05aj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,317.58s-9.42-8.39-12.8-2.14S87.31,323,93,317.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "86.2717px 317.054px"
    },
    id: "ellcpkqoorvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68,316.09s1.77-13.94,9.38-9.57S116.31,317.49,109.68,316.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "115.709px 310.977px"
    },
    id: "eli3lwriciid9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,336.06s-5.62-14.09,4.82-12.5S123.74,332.64,116.38,336.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "120.551px 329.747px"
    },
    id: "eljre4dtsgaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.36,341.09S91.54,330.71,84.81,334,83.58,347.62,100.36,341.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "91.1862px 338.283px"
    },
    id: "elpw1bxbnyla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.36,364.1s7.51-16.68,14.19-11.06S118.29,367.07,108.36,364.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "116.48px 358.3px"
    },
    id: "elmgq82p8zhpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.45,363.12s2-12.93-5.45-11.89S86.51,360.18,97.45,363.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "92.6217px 357.145px"
    },
    id: "elgcvm8uf3z7o",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M95.5,305.67a.46.46,0,0,1-.22-.06c-5.51-3.09-9.48-8.92-9.65-9.17a.46.46,0,0,1,.13-.63.44.44,0,0,1,.62.13c0,.05,3.82,5.61,8.94,8.65.85-1.56,3.88-6.94,6.41-8.46a.45.45,0,0,1,.62.16.43.43,0,0,1-.16.61c-2.69,1.62-6.25,8.45-6.29,8.52a.44.44,0,0,1-.27.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "93.9871px 300.702px"
    },
    id: "elr3ceblt6q7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,323a.47.47,0,0,1-.28-.09c-7.84-5.93-17.87-5.68-18-5.68a.48.48,0,0,1-.47-.44.45.45,0,0,1,.44-.46c.1,0,10.11-.26,18.15,5.57,1-1.68,5.08-7.75,10.25-10.79a.44.44,0,0,1,.62.16.43.43,0,0,1-.16.61c-5.7,3.36-10.15,10.83-10.2,10.9a.41.41,0,0,1-.3.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.064px 317.021px"
    },
    id: "el11129mnhzbda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.48,345.84a.46.46,0,0,1-.22-.06c-.12-.07-11.58-6.66-19.87-6.82a.45.45,0,1,1,0-.9c7.9.15,18.19,5.75,20,6.78,5.32-4.48,9.54-15.5,9.59-15.61a.45.45,0,1,1,.84.32c-.18.47-4.48,11.68-10.1,16.19A.43.43,0,0,1,109.48,345.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "104.399px 337.38px"
    },
    id: "elvw5wxlq4rrr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85,369.49a.46.46,0,0,1-.23-.06c-4.33-2.48-9.93-13.34-10.17-13.8a.45.45,0,0,1,.81-.41c0,.11,5.41,10.49,9.48,13.21a25.86,25.86,0,0,1,12.6-8.05.46.46,0,0,1,.56.31.45.45,0,0,1-.3.56,24.78,24.78,0,0,0-12.39,8A.42.42,0,0,1,102.85,369.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "104.16px 362.231px"
    },
    id: "elyypyj4ftzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,394.22s-3.61-5.74-7.68-6.56S88.53,382.15,87,385,89.67,397.15,102,394.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.3495px 389.438px"
    },
    id: "el3x1jyuqanq1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.32 416.75 122.7 416.75 125.34 392.46 80.69 392.46 83.32 416.75",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "103.015px 404.605px"
    },
    id: "eld84y4qll7un",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.77 397.06 126.26 397.06 126.85 391.92 79.17 391.92 79.77 397.06",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "103.01px 394.49px"
    },
    id: "elrhc21la2vi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldfv68dsnb8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "79.77 397.06 126.26 397.06 126.85 391.92 79.17 391.92 79.77 397.06",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "103.01px 394.49px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Streetlight--inject-26",
    className: "animable",
    style: {
      transformOrigin: "416.915px 280.125px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.9 154.06 425.48 186.91 408.36 186.91 404.94 154.06 428.9 154.06",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.92px 170.485px"
    },
    id: "el64fdy527lsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhphm8sd26bt"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.9 154.06 425.48 186.91 408.36 186.91 404.94 154.06 428.9 154.06",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "416.92px 170.485px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 413.73,
    y: 179.85,
    width: 6.37,
    height: 236.9,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.915px 298.3px"
    },
    id: "elwztu13gsq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwbu8ph3cn9h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.73,
    y: 179.85,
    width: 6.37,
    height: 236.9,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "416.915px 298.3px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "423.68 184.91 410.16 184.91 407.16 156.06 426.68 156.06 423.68 184.91",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "416.92px 170.485px"
    },
    id: "ele58afv00b2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqufmppb5qyc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.68 184.91 410.16 184.91 407.16 156.06 426.68 156.06 423.68 184.91",
    style: {
      fill: "rgb(255, 255, 255)",
      isolation: "isolate",
      opacity: 0.4,
      transformOrigin: "416.92px 170.485px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "415.14 185.36 414.22 185.36 413.22 155.06 414.14 155.06 415.14 185.36",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "414.18px 170.21px"
    },
    id: "el8v9ro0oq83w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc64wek1fpik"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "415.14 185.36 414.22 185.36 413.22 155.06 414.14 155.06 415.14 185.36",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "414.18px 170.21px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el13kxxzbynr3r"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.9 154.06 425.48 186.91 414.72 186.91 413.43 154.06 428.9 154.06",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "421.165px 170.485px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,143.5s-10.16,10-17.94,10l2.42,1.59h31l2.41-1.59C427.07,153.52,416.92,143.5,416.92,143.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.895px 149.295px"
    },
    id: "el58qps3duf44",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqw97g7iqgn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.85,153.52l-2.41,1.58h-31L399,153.52c7.78,0,17.93-10,17.93-10S427.07,153.52,434.85,153.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "416.925px 149.31px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwuchcym0bfq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.85,153.52l-2.41,1.58H412.28c-.61-1-1-1.71-1-1.71,5.41-2.51,5.68-9.89,5.68-9.89S427.07,153.52,434.85,153.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "423.065px 149.3px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.45,412.37h10.94a2.47,2.47,0,0,1,2.47,2.47v1.91a0,0,0,0,1,0,0H409a0,0,0,0,1,0,0v-1.91A2.47,2.47,0,0,1,411.45,412.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.93px 414.56px"
    },
    id: "elofipm5n6q4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7t0r2ebgkri"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.45,412.37h10.94a2.47,2.47,0,0,1,2.47,2.47v1.91a0,0,0,0,1,0,0H409a0,0,0,0,1,0,0v-1.91A2.47,2.47,0,0,1,411.45,412.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "416.93px 414.56px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-26",
    className: "animable",
    style: {
      transformOrigin: "174.72px 216.83px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.6,
    y: 117.54,
    width: 146.24,
    height: 198.58,
    rx: 7.83,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "174.72px 216.83px"
    },
    id: "elz0wqzgjv9bk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltlo656qp86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.6,
    y: 117.54,
    width: 146.24,
    height: 198.58,
    rx: 7.83,
    style: {
      fill: "rgb(255, 255, 255)",
      isolation: "isolate",
      opacity: 0.6,
      transformOrigin: "174.72px 216.83px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.36,170.79a19.64,19.64,0,1,1-19.64-19.63A19.62,19.62,0,0,1,194.36,170.79Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "174.72px 170.8px"
    },
    id: "elg2dfp08chuj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9w53k9b1ud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.36,170.79a19.64,19.64,0,1,1-19.64-19.63A19.62,19.62,0,0,1,194.36,170.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "174.72px 170.8px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 174.72,
    cy: 168.94,
    r: 7.03,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "174.72px 168.94px"
    },
    id: "el3jpi3z62vxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.19,186a19.65,19.65,0,0,1-24.93,0c1.84-5.39,5.63-9.37,10.18-10.38a10.52,10.52,0,0,1,4.56,0C181.56,176.6,185.34,180.58,187.19,186Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "174.725px 182.915px"
    },
    id: "el9ofkqhae5yh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(162.14 247.82)",
    style: {
      opacity: 0.5,
      fontSize: 4,
      fontFamily: "Montserrat-Regular, Montserrat"
    }
  }, "Sign up n", /*#__PURE__*/React.createElement("tspan", {
    x: 18.88,
    y: 0,
    style: {
      letterSpacing: "-0.02001953125em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.3,
    y: 0,
    style: {
      letterSpacing: "0.0001220703125em"
    }
  }, "w")), /*#__PURE__*/React.createElement("rect", {
    x: 126.99,
    y: 253.58,
    width: 95.47,
    height: 16.35,
    rx: 8.17,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "174.725px 261.755px"
    },
    id: "eljgm5h75cx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbxdc5667hhs"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "173.066px 279.389px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(156.73 280.86)",
    style: {
      fontSize: 4,
      fontFamily: "Montserrat-Regular, Montserrat"
    }
  }, "Forgot Pas", /*#__PURE__*/React.createElement("tspan", {
    x: 21.01,
    y: 0,
    style: {
      letterSpacing: "-0.0050048828125em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.87,
    y: 0,
    style: {
      letterSpacing: "-0.0198974609375em"
    }
  }, "w"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 26.36,
    y: 0
  }, "ord?"))))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(163.65 264.3)",
    style: {
      fontSize: 8,
      fill: "#fff",
      fontFamily: "Montserrat-Medium, Montserrat",
      fontWeight: 500
    }
  }, "Login"), /*#__PURE__*/React.createElement("rect", {
    x: 126.99,
    y: 198.38,
    width: 95.47,
    height: 16.35,
    rx: 8.17,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "174.725px 206.555px"
    },
    id: "el1m8zif5pppp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.99,
    y: 221.56,
    width: 95.47,
    height: 16.35,
    rx: 8.17,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "174.725px 229.735px"
    },
    id: "elhmexd9ik6xm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu2tmpy3nwk"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "158.051px 206.059px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(137.46 208.02)",
    style: {
      fontSize: 5,
      fontFamily: "Montserrat-Regular, Montserrat"
    }
  }, "Name@mail.", /*#__PURE__*/React.createElement("tspan", {
    x: 32.04,
    y: 0,
    style: {
      letterSpacing: "-0.02099609375em"
    }
  }, "c"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 34.76,
    y: 0
  }, "om"))))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(137.46 234.18)",
    style: {
      opacity: 0.5,
      fontSize: 7,
      fontFamily: "Montserrat-Regular, Montserrat"
    }
  }, "*******"), /*#__PURE__*/React.createElement("g", {
    id: "eljmkifuzc1y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.66,202.71v7.68h10.88v-7.68Zm9.1.84-3.66,2.5-3.67-2.5Zm-8.27,6v-5.63l4.61,3.14,4.6-3.14v5.63Z",
    style: {
      opacity: 0.2,
      transformOrigin: "211.1px 206.55px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el63wlbzzaj3p"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "211.095px 230.125px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.67,228.46v-.93a2.14,2.14,0,0,0-2.13-2.13h-1.16a2.14,2.14,0,0,0-2.13,2.13v.93H206.5v6.39h9.19v-6.39Zm-4.58-.93a1.29,1.29,0,0,1,1.29-1.29h1.16a1.29,1.29,0,0,1,1.29,1.29v.93h-3.74Zm5.77,6.48h-7.52V229.3h7.52Z",
    id: "eli6a47h20dc",
    className: "animable",
    style: {
      transformOrigin: "211.095px 230.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.86,231.91v.76h.48v-.76a.46.46,0,0,0,.23-.4.48.48,0,1,0-.95,0A.47.47,0,0,0,210.86,231.91Z",
    id: "elalkxcdv9xk5",
    className: "animable",
    style: {
      transformOrigin: "211.095px 231.815px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-26",
    className: "animable",
    style: {
      transformOrigin: "337.285px 170.945px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.66,145.65H322.93a8.85,8.85,0,0,0-8.85,8.85v25a8.85,8.85,0,0,0,8.85,8.85h11.36l3,7.89,3-7.89h11.36a8.84,8.84,0,0,0,8.84-8.85v-25A8.84,8.84,0,0,0,351.66,145.65Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "337.285px 170.945px"
    },
    id: "elkiyr8kwfcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln7v0paevjy7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.66,145.65H322.93a8.85,8.85,0,0,0-8.85,8.85v25a8.85,8.85,0,0,0,8.85,8.85h11.36l3,7.89,3-7.89h11.36a8.84,8.84,0,0,0,8.84-8.85v-25A8.84,8.84,0,0,0,351.66,145.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "337.285px 170.945px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.8,173.26a1.31,1.31,0,0,1-1-.46l-5.6-6.59a1.31,1.31,0,0,1,2-1.7l4.6,5.42,7.59-9a1.31,1.31,0,1,1,2,1.7L336.8,172.8A1.33,1.33,0,0,1,335.8,173.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "337.296px 166.862px"
    },
    id: "elw9rm5gk8zl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elezpec418a57"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 337.29,
    cy: 166.89,
    r: 14.26,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "337.29px 166.89px",
      transform: "rotate(-45deg)"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-26",
    className: "animable",
    style: {
      transformOrigin: "292.23px 310.056px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.69 416.75 397.29 416.75 383.79 340.56 377.19 340.56 390.69 416.75",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "387.24px 378.655px"
    },
    id: "ela8jjv5pz0mg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.53 416.75 252.14 416.75 238.64 340.56 232.03 340.56 245.53 416.75",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.085px 378.655px"
    },
    id: "elf2o6an94hr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell78szx9thef"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.69 416.75 397.29 416.75 383.79 340.56 377.19 340.56 390.69 416.75",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "387.24px 378.655px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsby8byj86x"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "245.53 416.75 252.14 416.75 238.64 340.56 232.03 340.56 245.53 416.75",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "242.085px 378.655px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp212b2ye0r"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.09,
    y: 378.65,
    width: 199.15,
    height: 6.69,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.665px 381.995px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0itsm5ie91zt"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.09,
    y: 378.65,
    width: 199.15,
    height: 6.69,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "287.665px 381.995px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "329.79 416.75 323.19 416.75 336.69 340.56 343.29 340.56 329.79 416.75",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.24px 378.655px"
    },
    id: "eljmn9rqiox0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.64 416.75 178.03 416.75 191.53 340.56 198.14 340.56 184.64 416.75",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "188.085px 378.655px"
    },
    id: "ela2jtpnxusl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elffzm1529y3v"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "329.79 416.75 323.19 416.75 336.69 340.56 343.29 340.56 329.79 416.75",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "333.24px 378.655px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elca1nnd2qo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "184.64 416.75 178.03 416.75 191.53 340.56 198.14 340.56 184.64 416.75",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "188.085px 378.655px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "244.52 337.59 251.09 337.59 262.09 276.44 255.52 276.44 244.52 337.59",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.305px 307.015px"
    },
    id: "el3aoqkydim3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwvefdmkcl3g"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "244.52 337.59 251.09 337.59 262.09 276.44 255.52 276.44 244.52 337.59",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "253.305px 307.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "375.01 337.59 381.58 337.59 392.58 276.44 386.01 276.44 375.01 337.59",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.795px 307.015px"
    },
    id: "elb0gzh03rib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.76 337.59 316.33 337.59 327.33 276.44 320.76 276.44 309.76 337.59",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.545px 307.015px"
    },
    id: "elh5lpxwzmih6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqcvgwmihxoe"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "375.01 337.59 381.58 337.59 392.58 276.44 386.01 276.44 375.01 337.59",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "383.795px 307.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el70e5bitkmr3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "309.76 337.59 316.33 337.59 327.33 276.44 320.76 276.44 309.76 337.59",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "318.545px 307.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "233.17 280.62 405.74 280.62 407.8 269.18 235.23 269.18 233.17 280.62",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.485px 274.9px"
    },
    id: "eluqe3i8otagr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.45 301.32 402.02 301.32 404.08 289.88 231.51 289.88 229.45 301.32",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.765px 295.6px"
    },
    id: "ele5w6u7m8v59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.72 322.02 398.29 322.02 400.35 310.58 227.78 310.58 225.72 322.02",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "313.035px 316.3px"
    },
    id: "el3iazjy8bm35",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elon0bbx3dc2j"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.66,
    y: 335.79,
    width: 219.93,
    height: 7.92,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "286.625px 339.75px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltakwe313duf"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "233.17 280.62 405.74 280.62 407.8 269.18 235.23 269.18 233.17 280.62",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "320.485px 274.9px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzq8zncx7p3f"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "229.45 301.32 402.02 301.32 404.08 289.88 231.51 289.88 229.45 301.32",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "316.765px 295.6px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxm40el8dy7s"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "225.72 322.02 398.29 322.02 400.35 310.58 227.78 310.58 225.72 322.02",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "313.035px 316.3px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7wz5sgvga3i"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.66,
    y: 335.79,
    width: 219.93,
    height: 7.92,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "286.625px 339.75px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbollb0lqf1b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.66,
    y: 335.79,
    width: 165.93,
    height: 7.92,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "259.625px 339.75px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,254.21c-4.65,4.91-15.8,16.94-22.7,16.73-7.28-.78-15.42-12-19.3-17.68A2.5,2.5,0,0,1,287.3,250c4.74,3.94,11.46,10.11,15.93,11.91-.68,0-.81.14-.19-.25,5.62-4,10.37-9.42,15.25-14.28,4.65-4.53,11.51,1.88,7.3,6.83Z",
    style: {
      fill: "rgb(233, 179, 118)",
      transformOrigin: "305.053px 258.39px"
    },
    id: "el8yqqfevtt5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.05,245.25v14.33s-3,2.52-6.75,5.3c-1.86,1.39-3.89,2.84-5.79,4.07-2.89,1.88-5.49,3.26-6.81,3.18-3.94-.24-12.49-6.35-12.49-6.35l5.62-9.36s6.46,3.95,6.87,4.22S317.66,245.34,323.05,245.25Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "307.13px 258.692px"
    },
    id: "el8xkgb68ue4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpsdgruu7zua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.3,264.88c-1.86,1.39-3.89,2.84-5.79,4.07.45-8.22,4.32-11.38,4.32-11.38A14.27,14.27,0,0,1,316.3,264.88Z",
    style: {
      opacity: 0.2,
      transformOrigin: "313.42px 263.26px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.51,207.57c-6.9,5.63-6.08,21.83,1.67,32.46,0,0,16.56,1.39,25.76-2.73s-1-30.35-10.69-32.41A23.19,23.19,0,0,0,328.51,207.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.677px 222.305px"
    },
    id: "elfgz14gds0pw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.92,224.4c-2.53-4.36-5-16.13,5.47-19.76,13.13-4.54,19,3.83,20.15,12.13s-3.54,14.57-12.22,13.95S330.66,227.42,328.92,224.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.712px 217.061px"
    },
    id: "eld61yucdz6kr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.82,257.57c-1.28,6.07,1,20.37,1.34,31.15l30.92,3.56c0-3.38.63-8.28,2.65-16.07,1.15-4.56,2.81-10.12,5.08-16.94.33-1,.68-2,1-3.11a7.69,7.69,0,0,0-6-10.33c-1.3-.21-2.68-.39-4.09-.53a104,104,0,0,0-15-.79c-1.63.05-3.33.17-4.95.31C320,245.31,316,251.89,314.82,257.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.373px 268.385px"
    },
    id: "el8ao7dv6tneu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57,228.41c-1.55,4.74-3.62,13.47-.66,16.84,0,0-4.52-.92-14.51,4.54-2.59-4.16-.44-5.33-.44-5.33,5.53-1,5.89-5,5.44-8.73Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "337.346px 239.1px"
    },
    id: "eljracoysbxch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt2n4susna3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.43,231.39l-6,4.33a15,15,0,0,1,.12,2.67c2.09-.19,5.19-2.28,5.68-4.4A7.18,7.18,0,0,0,341.43,231.39Z",
    style: {
      opacity: 0.2,
      transformOrigin: "338.45px 234.89px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,217.34c.11,7.91.32,11.26-3.36,15.6-5.52,6.53-15.27,4.93-17.74-2.79-2.22-7-2-18.73,5.46-22.44A10.8,10.8,0,0,1,347.64,217.34Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "336.498px 221.79px"
    },
    id: "elytg4cbfak4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.93,209.94c-2.19,2.75,2.8,11.41,6.74,12.88C355.32,220.3,347.48,201.73,340.93,209.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "345.611px 215.34px"
    },
    id: "el49zdiex08fp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.56,206.25c-2.91,1.28-5.64,6.75-6,8.79,4.33.33,15.48-4.67,15.48-4.67s7.85,1.44,3.63-2.1S331.56,206.25,331.56,206.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.738px 210.491px"
    },
    id: "el5te483kr525",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.48,220.56c0,.64-.25,1.18-.67,1.22s-.8-.47-.85-1.11.26-1.18.68-1.22S334.43,219.92,334.48,220.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.717px 220.615px"
    },
    id: "el0f4cy0oau5ql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.23,221.1c0,.64-.25,1.19-.67,1.22s-.8-.46-.85-1.1.26-1.19.68-1.22S327.18,220.46,327.23,221.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.467px 221.16px"
    },
    id: "el1eul5kh9g38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.57,220l-1.57-.33S325.88,220.83,326.57,220Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "325.785px 219.985px"
    },
    id: "elyl1rpz03kp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.31,221.9a17.66,17.66,0,0,1-2,4.27,2.78,2.78,0,0,0,2.32.25Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "329.47px 224.233px"
    },
    id: "elqf7uobngvhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.33,228.67a6.38,6.38,0,0,1-.94.15.19.19,0,0,1,0-.38,5.07,5.07,0,0,0,4-2.3.18.18,0,0,1,.25-.07.19.19,0,0,1,.08.25A5.27,5.27,0,0,1,334.33,228.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.47px 227.433px"
    },
    id: "elbllc11v9n9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.31,224.4a5.76,5.76,0,0,1-2.76,3.45c-1.78,1-3.12-.53-3-2.45.11-1.72,1.17-4.3,3.15-4.48A2.6,2.6,0,0,1,350.31,224.4Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "347.504px 224.54px"
    },
    id: "el0srlflp42xhl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,218.68a.39.39,0,0,1-.41-.18c-.9-1.49-3.14-1.67-3.16-1.67a.38.38,0,0,1,.05-.76c.11,0,2.66.22,3.76,2a.38.38,0,0,1-.13.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.184px 217.378px"
    },
    id: "el8wwi5kg5vsj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.56,217.73a.37.37,0,0,1-.36-.11.37.37,0,0,1,0-.53,3.71,3.71,0,0,1,3.28-1.05.37.37,0,0,1-.17.73h0a3,3,0,0,0-2.59.86A.42.42,0,0,1,325.56,217.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.929px 216.863px"
    },
    id: "elkvsunyq4uy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.82,219.48l-1.57-.33S333.13,220.29,333.82,219.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.035px 219.46px"
    },
    id: "el3e36ef2jn4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.72,248.69l.75,2.34a2.85,2.85,0,0,0,1.85,1.85l4.12,1.32a5.32,5.32,0,0,0,4.83-.81l.85-.64c-1-4-4.95-7.54-4.95-7.54l-1-1.15a2.39,2.39,0,0,0-3.37-.27l-2.29,2A2.73,2.73,0,0,0,305.72,248.69Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "311.852px 248.838px"
    },
    id: "el4rf2pb3p9fo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,250.83l.75,2.35a2.88,2.88,0,0,0,1.86,1.85l4.11,1.32a5.35,5.35,0,0,0,4.83-.81l.86-.64c-1-4-5-7.55-5-7.55l-1-1.14a2.38,2.38,0,0,0-3.38-.27l-2.29,2A2.75,2.75,0,0,0,278,250.83Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "284.134px 250.982px"
    },
    id: "elg52h81l0hu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell78p088z0y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.8,263.39c2,5.86,7.07,10.23,11.93,12.82,1.15-4.56,2.81-10.12,5.08-16.94-3.05-4.26-7.32-7.29-12.76-6.47C342.05,252.8,335.79,257.46,337.8,263.39Z",
    style: {
      opacity: 0.2,
      transformOrigin: "346.106px 264.438px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.07,379.65l5.22,2.11s44.35-66.9,48.46-64.39c14.87,9.11,45.44,25.39,59.91,15.53s5.88-35.85,5.88-35.85-28.14-9.88-31.62-3.77a47.31,47.31,0,0,0-2.39,5.63c-.72,1.93-1.28,3.56-1.28,3.56h0c-.85-.4-28.43-13.67-41.42-8.2C257.62,299.82,228.07,379.65,228.07,379.65Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "289.071px 336.523px"
    },
    id: "elmzdj1ynczwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.25,336.47s-13.95.91-33.06-5.58c0,0-4.71,53.28-7.88,82.2l-6.4-.9s-10.89-78.94-8.74-88.56S282,313.37,282,313.37,304.27,329.74,324.25,336.47Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "296.069px 363.23px"
    },
    id: "el2zg431pntll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.25,336.47A103.8,103.8,0,0,1,296.34,333l1.82-7.58C305.19,330.07,315,332.9,324.25,336.47Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "310.295px 330.949px"
    },
    id: "el1ia4ai6xt7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpt36t158prf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.25,336.47A103.8,103.8,0,0,1,296.34,333l1.82-7.58C305.19,330.07,315,332.9,324.25,336.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "310.295px 330.949px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "296.98 324.65 295.31 333.09 297.85 333.96 299.81 326.51 296.98 324.65",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "297.56px 329.305px"
    },
    id: "elxz0s6ofcchi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el88zr0qrcicn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "296.98 324.65 295.31 333.09 297.85 333.96 299.81 326.51 296.98 324.65",
    style: {
      fill: "rgb(255, 255, 255)",
      isolation: "isolate",
      opacity: 0.6,
      transformOrigin: "297.56px 329.305px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el39dbxocngy9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.49,357.18c-1-21-1.44-31.84,2-36.17a15.22,15.22,0,0,1,8.85-5.12c4.48,11.35,24,18.43,24.54,18.62h0c7.29,1.51,18.09,1.9,18.36,2a71.87,71.87,0,0,1-26.09-11A164.6,164.6,0,0,1,282,313.38s-11.65.63-13.8,10.25c-.88,3.94.42,19.46,2.26,36.45A26.53,26.53,0,0,0,270.49,357.18Z",
    style: {
      isolation: "isolate",
      opacity: 0.2,
      transformOrigin: "296.079px 336.73px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.86,375.26a.83.83,0,0,1,.2-.94.93.93,0,0,1,.67-.35,3.68,3.68,0,0,1,1.89.63c-.49-.64-.87-1.33-.7-1.76.11-.28.39-.43.84-.43a1.36,1.36,0,0,1,1.05.45c.87.95.68,3.12.68,3.22a.3.3,0,0,1,0,.1.1.1,0,0,1,0,.05.18.18,0,0,1-.07,0h-.08a14.3,14.3,0,0,1-2.79-.21C223.72,375.93,223.06,375.68,222.86,375.26Zm.91-.82a.47.47,0,0,0-.35.17c-.23.28-.17.41-.15.45.24.48,1.91.72,3.32.76C225.78,375.21,224.51,374.37,223.77,374.44Zm2-1.57c-.13,0-.36,0-.41.14-.14.37.72,1.52,1.69,2.52a3.79,3.79,0,0,0-.58-2.36.88.88,0,0,0-.48-.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.15px 374.322px"
    },
    id: "elpoj2xl5iqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.65,407.62a.85.85,0,0,1-.22-.94.94.94,0,0,1,.46-.6,3.67,3.67,0,0,1,2-.24c-.72-.37-1.35-.83-1.38-1.29q0-.45.57-.75a1.34,1.34,0,0,1,1.14,0c1.2.48,2,2.52,2,2.61a.22.22,0,0,1,0,.11h0a.43.43,0,0,1,0,0h0a.14.14,0,0,1-.05.08l-.05.05h0a10.92,10.92,0,0,1-3.67,1.16A1.21,1.21,0,0,1,270.65,407.62Zm.48-1.14a.47.47,0,0,0-.25.31c-.09.35,0,.44.06.47.42.33,2-.17,3.32-.74C273.27,406.32,271.76,406.11,271.13,406.48Zm1.12-2.26c-.12.06-.32.17-.31.3,0,.39,1.29,1.06,2.61,1.54a3.82,3.82,0,0,0-1.54-1.87.83.83,0,0,0-.34-.07A.92.92,0,0,0,272.25,404.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.799px 405.745px"
    },
    id: "el6156iii64ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.58,379.51c.29-.66-8-3.84-8-3.84s-7.23,2.74-12.54,1.66-4,3,1.4,5.48l13.22,6.1C234.51,390.66,233.63,386.33,236.58,379.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "224.624px 382.485px"
    },
    id: "elpybgqycjnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87,405.56c0-.72-8.83-.05-8.83-.05s-5.36,5.58-10.61,6.88-2.27,4.43,3.62,4.36l14.56-.18C287.79,416.52,285.13,413,284.87,405.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.327px 410.989px"
    },
    id: "elrs3g4xnloe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,297.05s-28.14-9.88-31.62-3.77a49,49,0,0,0-2.39,5.63c-.72,1.93-1.28,3.56-1.28,3.56h0l-2.31-1.06-9.42,28.13c15,8.32,36.17,9.28,44.85,3.37C359.81,323.05,347.54,297.05,347.54,297.05Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "326.462px 313.985px"
    },
    id: "el6lcjlrg3qpq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt46664swhxj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "326.462px 313.985px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.54,297.05s-28.14-9.88-31.62-3.77a49,49,0,0,0-2.39,5.63c-.72,1.93-1.28,3.56-1.28,3.56h0l-2.31-1.06-9.42,28.13c15,8.32,36.17,9.28,44.85,3.37C359.81,323.05,347.54,297.05,347.54,297.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "326.462px 313.985px"
    },
    id: "el7tj5ho6txf3",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elx0soifr13d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25,302.47l16.23,6.89s-8.33-7-15-10.45C312.81,300.84,312.25,302.47,312.25,302.47Z",
    style: {
      isolation: "isolate",
      opacity: 0.3,
      transformOrigin: "320.365px 304.135px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "315.52 294.05 316.09 287.11 347.54 291.29 347.95 297.99 315.52 294.05",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "331.735px 292.55px"
    },
    id: "elmje5qfotpwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgfh5858zf7h"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "315.52 294.05 316.09 287.11 347.54 291.29 347.95 297.99 315.52 294.05",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "331.735px 292.55px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "316.15 287.79 317.8 288.03 317.29 293.44 315.93 293.28 316.15 287.79",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.865px 290.615px"
    },
    id: "elijec0turxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.36 288.25 337.09 290.83 336.63 295.75 318.86 293.63 319.36 288.25",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.975px 292px"
    },
    id: "el3btzxt93aj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.54 297.05 338.19 295.94 338.65 291.06 338.65 291.06 347.09 292.28 347.54 297.05",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "342.865px 294.055px"
    },
    id: "elkl8eoq7g16p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv42qilb7ux"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.15 287.79 317.8 288.03 317.29 293.44 315.93 293.28 316.15 287.79",
    style: {
      isolation: "isolate",
      opacity: 0.2,
      transformOrigin: "316.865px 290.615px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvqxbdsca8f"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "319.36 288.25 337.09 290.83 336.63 295.75 318.86 293.63 319.36 288.25",
    style: {
      isolation: "isolate",
      opacity: 0.2,
      transformOrigin: "327.975px 292px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4k74u2r99e8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "347.54 297.05 338.19 295.94 338.65 291.06 338.65 291.06 347.09 292.28 347.54 297.05",
    style: {
      isolation: "isolate",
      opacity: 0.2,
      transformOrigin: "342.865px 294.055px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.75,295.46h-.19l-5.05-.67a1.43,1.43,0,0,1-.95-.55,1.41,1.41,0,0,1-.29-1.06l.45-3.38a1.48,1.48,0,0,1,.55-1,1.44,1.44,0,0,1,1.06-.28l5.05.67a1.43,1.43,0,0,1,1.24,1.61l-.45,3.38A1.43,1.43,0,0,1,328.75,295.46Zm-4.61-5.92a.43.43,0,0,0-.26.09.46.46,0,0,0-.17.29l-.44,3.38a.41.41,0,0,0,.08.32.46.46,0,0,0,.29.17h0l5.05.67a.44.44,0,0,0,.49-.38l.45-3.38a.45.45,0,0,0-.09-.32.46.46,0,0,0-.29-.17l-5.05-.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "326.445px 291.984px"
    },
    id: "el659w0y8mn7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,292.78h-.08l-1.78-.29a.49.49,0,0,1-.41-.57.51.51,0,0,1,.57-.42l1.78.29a.5.5,0,0,1-.08,1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "328.131px 292.143px"
    },
    id: "elyohp5izplu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.58 299.46 311.2 300.84 302.31 331.06 298.58 330.32 308.58 299.46",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "304.89px 315.26px"
    },
    id: "el54n338ux3yh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el90hv914umil"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "308.58 299.46 311.2 300.84 302.31 331.06 298.58 330.32 308.58 299.46",
    style: {
      fill: "rgb(255, 255, 255)",
      isolation: "isolate",
      opacity: 0.6,
      transformOrigin: "304.89px 315.26px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.48,269h-22a1.71,1.71,0,0,1-1.67-1.54l-3.07-29.25a1.39,1.39,0,0,1,1.4-1.54h22a1.72,1.72,0,0,1,1.68,1.54l3.06,29.25A1.38,1.38,0,0,1,306.48,269Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.811px 252.835px"
    },
    id: "elseu016ga9jr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5iviu5jqskl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.48,269h-22a1.71,1.71,0,0,1-1.67-1.54l-3.07-29.25a1.39,1.39,0,0,1,1.4-1.54h22a1.72,1.72,0,0,1,1.68,1.54l3.06,29.25A1.38,1.38,0,0,1,306.48,269Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "293.811px 252.835px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elamjqb7zpgpr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.56,269H284.45a1.71,1.71,0,0,1-1.67-1.54l-3.07-29.25a1.39,1.39,0,0,1,1.4-1.54h21.11a1.71,1.71,0,0,1,1.67,1.54L307,267.41A1.38,1.38,0,0,1,305.56,269Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "293.359px 252.836px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.71,250.39a2.15,2.15,0,0,0-2.17,2.39,2.65,2.65,0,0,0,2.59,2.4,2.16,2.16,0,0,0,2.17-2.4A2.66,2.66,0,0,1,292.71,250.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "292.92px 252.785px"
    },
    id: "elvhstncku9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elll2j9xw5zkb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.48,238.94H285.84a1.54,1.54,0,0,1-1.36-.88l-.7-1.44h15.36l-.45,1.44A1.24,1.24,0,0,1,297.48,238.94Z",
    style: {
      opacity: 0.3,
      transformOrigin: "291.46px 237.78px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.66,305.87h-4.09s-5.11-15.34-8.09-28.34a94.31,94.31,0,0,1-1.91-10.43,29.9,29.9,0,0,1,1-11.58,29,29,0,0,1,5.18-10.22l-.83-.05c7.74-.08,11.92,2.6,12.44,7.42s-8,33.42-8.44,37.24S353.66,305.87,353.66,305.87Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "348.387px 275.559px"
    },
    id: "el0dbvjd5n0srj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.24,244.71s-8.19,12.9-10.38,18.38-.93,21.18-.93,21.18-4.19-18.89-1.5-28.25S321.79,244.74,327.24,244.71Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "320.384px 264.49px"
    },
    id: "elxg9tm1eg2x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28,256.34c-4.31,6.18-14.6,20.69-23.46,17.29-4.67-2.13-8-6-11.09-9.75a79.72,79.72,0,0,1-7.21-10.78,2.49,2.49,0,0,1,4-2.95c2.84,2.95,5.8,5.91,8.75,8.65,2.57,2.32,5.87,5.34,8.85,6.43a1.9,1.9,0,0,0-.66-.17c-.17,0-.13,0,0-.11,5-3.42,8.84-9.3,12.55-14.19,3.86-5.33,11.77,0,8.29,5.58Z",
    style: {
      fill: "rgb(233, 179, 118)",
      transformOrigin: "334.643px 261.349px"
    },
    id: "elje6ffe8f11o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el449qmjahd42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.2,260s-7.2,12.28-12.72,17.49a94.31,94.31,0,0,1-1.91-10.43,29.9,29.9,0,0,1,1-11.58l5.7-4.7C349.1,248.45,354.2,260,354.2,260Z",
    style: {
      opacity: 0.2,
      transformOrigin: "346.796px 263.98px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.71,248.68c3.77,2,2.63,7.47-2.31,13.93s-13.88,15.19-18.58,13.6-10-7.84-10-7.84l3.43-9.68s6.73,5.11,8.13,4.85,8.26-9.14,10.24-11.89S350.62,246.47,354.71,248.68Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "340.384px 262.11px"
    },
    id: "elyk0a9zqm8vd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.43,249.25l-.14,1.92a2.2,2.2,0,0,1-1.87,2l-2.61.39.62-7,2.18.38A2.19,2.19,0,0,1,284.43,249.25Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "282.123px 250.06px"
    },
    id: "ellu15gej89vr",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletLoginAnimate);
export default __webpack_public_path__ + "static/media/tablet-login-animate.747abb597db6255ac6e82aa2027dd975.svg";
export { ForwardRef as ReactComponent };